import config from "../config";
import { AddressApiResponseDto } from "../dtos/address/addressApiResponseDto";
import { getData } from "../utils/axios/serverHelper";

const baseUrl = "https://business.juso.go.kr/addrlink/addrLinkApi.do";

interface SearchParams {
    keyword: string,
    hstryYn: string,
    resultType: string,
    confmKey: string,
    currentPage: string,
    countPerPage: string,
}

export const searchAddress = async (search: string, page: number, size: number) => {

    const url = baseUrl;

    const params: SearchParams = {
        keyword: search,
        hstryYn: "Y",
        resultType: "json",
        confmKey: config.addressApiKey ?? "",
        currentPage: page.toString(),
        countPerPage: size.toString()
    }

    const response = await getData<AddressApiResponseDto>(url, {
        params,
        withCredentials: false,
    })

    return response;

}